import * as React from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";
import './RoleManagementStyling.css';
import { createRole, getCurrentIdpClients } from '../../ApiUtils/ApiUtils';
import { KeycloakClient } from '../Management/IdpConfigureForm';
import { Role } from './RoleList';

//export interface Role {
//    name: string,
//    description: string,
//    composite: boolean,
//    clientRole: boolean,
//    containerId: string,
//}

interface DuplicateClient {
    clientId: string;
    name: string;
}

const InitialState: { clients: KeycloakClient[], nameError: string} = {
    clients: [],
    nameError: "",
}
type State = typeof InitialState;

type RoleCreateFormProps = {
    realmName: string;
    userRealm?: string;
    clientProp: any;
    clientId?: string
    toggleDialog: (name?: string, created?: boolean) => void;
};

class RoleCreateForm extends React.Component<RoleCreateFormProps, State> {

    public constructor(props: RoleCreateFormProps) {
        super(props);
        this.state = {
            clients: [],
            nameError: "",
        };
    }

    componentDidMount() {
        this.getClients(this.props.realmName, this.props.userRealm ?? '');
    }

    private getClients = (realmName: string, userRealm: string) => {
        getCurrentIdpClients(realmName, userRealm,true).then((dataArray) => {
            this.setState({ clients: JSON.parse(dataArray) });
        });
    }

    private handleSubmit = (e: React.ChangeEvent<any>) => {
        var clientIds: string[] = [];
        //Get list of clients available in currently selected realm.
        this.state.clients.forEach((client) => {
            clientIds.push(client.clientId);
        })
        event?.preventDefault();
        if (e.target.elements.name.value === "root" || e.target.elements.name.value === "access" || e.target.elements.name.value === "admin") {
            this.setState({ nameError: "Cannot create role with name " + e.target.elements.name.value });
        }
        if (e.target.elements.name.value.trim() === "") {
            this.setState({ nameError: "Cannot create role with blank name." });
        }
        else {
            this.setState({ nameError: "" })
            const newRole: Role = {
                name: e.target.elements.name.value,
                description: e.target.elements.desc.value,
                composite: false,
                clientRole: true,
                containerId: this.state.clients[clientIds.indexOf(this.props.clientProp.clientId)].id
            };
            createRole(newRole, this.props.realmName).then((response) => {
                this.props.toggleDialog("", true);
            });
        }
    }

    private handleChange = (e: React.ChangeEvent<any>) => {
       /* if (e.currentTarget.value.includes(":")) {
            e.currentTarget.value = e.currentTarget.value.replace(/:/g, "");
        }*/
        //commented to allow creating project_mmember: roles. Still must implement restriction server side => allow  ':' in role name only if role  begins with 'project_member:'
    };

    public render() {
        return (
            <>
                <Dialog
                    title={"Create Role"}
                    onClose={() => this.props.toggleDialog()}
                    style={{ fontSize: "8px" }}
                    width={500}
                    height={"100%"}
                >
                    <form onSubmit={this.handleSubmit} style={{ fontSize: "11px", padding: "10px 15px 0px" }}>
                        <div>
                            <div>
                                <label htmlFor="name">Name</label><br />
                                <input type="text" name="name" id="name" className="form-control" onChange={this.handleChange} /><br /><br />
                                {this.state.nameError && (
                                    <>
                                        <span className="error-span">{this.state.nameError}</span><br /><br />
                                    </>
                                )}
                                <label htmlFor="desc">Description</label><br />
                                <input type="text" name="desc" id="desc" className="form-control" /><br /><br />
                                <hr />
                            </div>
                        </div>
                        <input type="submit" value="Create" className={"btn btn-primary"} style={{ marginRight: "10px" }} />
                        <button className={"btn btn-secondary"} style={{ marginRight: "15px" }} onClick={() => this.props.toggleDialog()}>Cancel</button>
                    </form>
                </Dialog>
            </>
        );
    }
}

export default RoleCreateForm;